export default function (step) {
    var _goBackFn = void 0;

    /**
     * Provide a function with logic about how to go backwards in the flow
     *
     * The arguments to this function are model, extraArgs
     *
     * @param {Function} goBackFn
     * @returns {*}
     */
    return function (goBackFn) {
        if (arguments.length === 0) {
            // previous function takes model and extraArgs parameters
            return _goBackFn;
        }
        _goBackFn = goBackFn;
        return step;
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/flow/build/Previous.js
// module id = 760
// module chunks = 0